import {
  DETAILS_PAGE_PATH,
  OVERVIEW_PAGE_PATH,
  RESULT_PATH_IV24,
  VALUATION_FUNNEL_PATH,
  VALUATION_FUNNEL_PATH_IV24,
} from '@/router/routes/constants';
import { Pages } from '@/types';
import { HgSupportedLanguage } from '@smg-real-estate/domus';

export const isTargetPageByPath = (
  path: string,
  routes: Record<HgSupportedLanguage, string>,
  dynamicParams = false,
): boolean => {
  const valuationPaths = Object.values(routes).map((route) => {
    const regexPath = dynamicParams ? route.replace(/:([^/]+)/g, '[^/]+') : route;
    return new RegExp(`^${regexPath.replace(/\//g, '\\/')}\\/?$`);
  });

  return valuationPaths.some((regex) => regex.test(path));
};

export const getLoginCallbackUrl = (includeOrigin = true): string => {
  const stage = import.meta.env.VUE_APP_STAGE;
  const isPersonalOrMrStage = stage === 'personal' || stage === 'dev';

  // personal/mr(dev) behavior: include BASE_URL prefix when available.
  if (isPersonalOrMrStage) {
    const path = `${import.meta.env.BASE_URL}en/property-valuation/login-callback`;

    if (includeOrigin) return `${window.location.origin}${path}`;
    return '/en/property-valuation/login-callback';
  } else {
    const path = `/en/property-valuation/login-callback`;
    if (includeOrigin) return `${window.location.origin}${path}`;
    return path;
  }
};

export const isFunnelPage = (path: string): boolean => {
  return isTargetPageByPath(path, VALUATION_FUNNEL_PATH);
};

export const isIV24FunnelPage = (path: string): boolean => {
  return isTargetPageByPath(path, VALUATION_FUNNEL_PATH_IV24);
};

export const isIV24ResultPage = (path: string): boolean => {
  return isTargetPageByPath(path, RESULT_PATH_IV24);
};

export const isHowPage = (routeName: `${Pages}-${HgSupportedLanguage}`): boolean => {
  if (!routeName) return false;
  const nonLocalizedRouteName = routeName.split('-')[0];
  return Object.values(Pages).includes(nonLocalizedRouteName as Pages);
};

export const getPage = (path: string): Pages | null => {
  // Match the router order from specific to general
  const pages = {
    [Pages.PDP]: isTargetPageByPath(path, DETAILS_PAGE_PATH, true),
    [Pages.PropertyOverview]: isTargetPageByPath(path, OVERVIEW_PAGE_PATH),
  };
  return (Object.keys(pages).find((key) => pages[key]) as Pages) ?? null;
};
